import * as fetch from '../../../utils/action'
import { getTotalNumber, downloadFilename } from '../totalMethod'
import mallOrderDatas from '../datas/mall-order'
export default {
  getMallOrders (ctx, data) {
    return fetch.getMallOrders(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallOrderDatas.getMallOrders(result.data)
      return result
    })
  },
  getMallOrderOfAll (ctx, data) {
    return fetch.getMallOrderOfAll(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallOrderDatas.getMallOrders(result.data)
      return result
    })
  },
  goodsOrderDetail (ctx, id) {
    return fetch.goodsOrderDetail(id).then(res => {
      let result = res.data
      result.mallOrder = mallOrderDatas.goodsOrderDetail(result.mallOrder)
      return result
    })
  },
  getOrderInvoice (ctx, id) {
    return fetch.getOrderInvoice(id).then(res => {
      let result = mallOrderDatas.getOrderInvoice(res.data)
      return result
    })
  },
  // 下载发票
  downloadInvoice (ctx, id) {
    return fetch.downloadInvoice(id).then(res => {
      return res.data
    })
  },
  refundmentOrders (ctx, data) {
    return fetch.refundmentOrders(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallOrderDatas.getMallOrders(result.data)
      return result
    })
  },
  rejectRefundment (ctx, data) {
    return fetch.rejectRefundment(data).then(res => {
      return res.data
    })
  },
  // 订单详情获取订单状态
  getOrderProgress (ctx, id) {
    return fetch.getOrderProgress(id).then(res => {
      let result = mallOrderDatas.getOrderProgress(res.data)
      return result
    })
  },
  // 导出退款订单列表excel
  exportForRefundment (ctx, data) {
    return fetch.exportForRefundment(data).then(res => {
    //   let result = downloadFilename(res)
      return res
    })
  },
  // 导出全部订单excel
  exportAllOrder (ctx, data) {
    return fetch.exportAllOrder(data).then(res => {
    //   let result = (res.headers['content-disposition'] && downloadFilename(res)) || null
      return res
    })
  },
  exportResampleOrder (ctx, data) {
    return fetch.exportResampleOrder(data).then(res => {
      let result = downloadFilename(res)
      return result
    })
  },
  // 导出咨询工单
  exportConsulting (ctx, data) {
    return fetch.exportConsulting(data).then(res => {
      let result = downloadFilename(res)
      return result
    })
  },
  sampleOrderDetail (ctx, sampleId) {
    return fetch.sampleOrderDetail(sampleId).then(res => {
      return res.data
    })
  },
  // 获取带重采订单列表
  waitingForSampleRecollect (ctx, data) {
    return fetch.waitingForSampleRecollect(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallOrderDatas.waitingForSampleRecollect(result.data)
      return result
    })
  },
  // 创建重采订单
  creatSampleRecollect (ctx, data) {
    return fetch.creatSampleRecollect(data).then(res => {
      return res.data
    })
  },
  sampleRecollectPrice (ctx, sampleId) {
    return fetch.sampleRecollectPrice(sampleId).then(res => {
      return res.data
    })
  },
  sampleRecollectPriceAdultlab (ctx, sampleId) {
    return fetch.sampleRecollectPriceAdultlab(sampleId).then(res => {
      return res.data
    })
  },
  // 关闭订单
  closeOrder (ctx, id) {
    return fetch.closeOrder(id).then(res => {
      return res.data
    })
  },
  getExpresses (ctx, data) {
    return fetch.getExpresses(data).then(res => {
      return res.data
    })
  },
  createExporess (ctx, data) {
    return fetch.createExporess(data).then(res => {
      return res.data
    })
  },
  // 获取订单退款原因
  getRefundmentReason (ctx, data) {
    return fetch.getRefundmentReason(data).then(res => {
      return res.data
    })
  },
  // 获取全部商品类型
  getGoodsTypes (ctx) {
    return fetch.getGoodsTypes().then(res => {
      ctx.commit('goodsTypeList', res.data)
      return res.data
    })
  },
  // 使用example对象为当前用户查询存储项列表
  exportHistoryList (ctx, data) {
    return fetch.exportHistoryList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallOrderDatas.exportHistoryList(result.data)
      return result
    })
  },
  // 使用example对象为当前用户查询存储项列表(实验室订单)
  labExportHistoryList (ctx, data) {
    return fetch.labExportHistoryList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallOrderDatas.exportHistoryList(result.data)
      return result
    })
  },
  // 使用example对象为当前用户查询存储项列表(成人实验室订单)
  AdultlabExportHistoryList (ctx, data) {
    return fetch.AdultlabExportHistoryList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallOrderDatas.exportHistoryList(result.data)
      return result
    })
  },
  exportHistoryDownload (ctx, id) {
    return fetch.exportHistoryDownload(id).then(res => {
      let result = res.data
      return result
    })
  },
  getPlaceOrder (ctx, id) {
    return fetch.getPlaceOrder(id).then(res => {
      let result = res.data
      return result
    })
  },
  getOperationalPromotion (ctx) {
    return fetch.getOperationalPromotion().then(res => {
      return res.data
    })
  },
  editOrderInfo (ctx, data) {
    return fetch.editOrderInfo(data).then(res => {
      return res.data
    })
  },
  getOrderHistory (ctx, id) {
    return fetch.getOrderHistory(id).then(res => {
      let result = mallOrderDatas.getOrderHistory(res.data)
      return result
    })
  },
  exportHistoryListPay (ctx, data) {
    return fetch.exportHistoryListPay(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallOrderDatas.exportHistoryList(result.data)
      return result
    })
  },
  // 使用example对象为投保信息的导出列表
  exportHistoryListFormerop (ctx, data) {
    return fetch.exportHistoryListFormerop(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallOrderDatas.exportHistoryList(result.data)
      return result
    })
  },
  deleteMallOrder (ctx, id) {
    return fetch.deleteMallOrder(id).then(res => {
      return res.data
    })
  }
}
